{
  "it": {
    "todo_v2": {
      "actions": {
        "confirm": "Contrassegna come completata",
        "create": "Attività",
        "reopen": "Riapri",
        "update": "Modifica attività"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Dipendente",
        "partner": "Partner"
      },
      "attributes": {
        "assignees": "Responsabili",
        "created_at": "Creato",
        "due_date": "Scadenza",
        "project": "Progetto",
        "status": "Stato",
        "todo_group": "Attività",
        "unit": "Unità"
      },
      "labels": {
        "add_assignee": "Aggiungi un responsabile…",
        "add_customers": "Aggiungi clienti",
        "completed": "Completata",
        "confirm_message": "È sicuro di voler contrassegnare questa attività come completata?",
        "customers": "Clienti",
        "group_already_added": "Questa attività è già stata aggiunta a questa unità.",
        "my_todos": "Le mie attività",
        "no_assignees": "Ancora nessun responsabile assegnato.",
        "no_todos": "Ancora nessuna attività.",
        "no_todos_group": "Ancora nessuna attività in questo gruppo.",
        "no_todos_unit": "Ancora nessuna attività per questa unità.",
        "publish_all": "Pubblica tutto",
        "publish_customers": "Pubblica per i clienti di ogni unità",
        "published": "Pubblicata",
        "required": "Questo campo è obbligatorio",
        "select_group": "Selezioni un'attività",
        "upload_hint": "Carichi i documenti richiesti per completare questa attività.",
        "uploaded_documents": "Documenti caricati"
      },
      "statuses": {
        "completed": "Completata",
        "draft": "Bozza",
        "pending": "In attesa"
      },
      "toasts": {
        "completed": "Attività completata",
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "uncompleted": "Attività riaperta",
        "update": "Attività aggiornata"
      }
    }
  }
}
